import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { baseTheme } from "@appcues/theme-utilities";
import Input from "components/Common/Forms/Input";

const ThemeSlider = ({ label, draftTheme, setDraftTheme, unit, max }) => {
  const handleChange = useCallback(
    evt => {
      const labelName = label.name;
      const value = evt.target.value;
      setDraftTheme(prevDraftTheme => {
        return { ...prevDraftTheme, [labelName]: value };
      });
    },
    [setDraftTheme]
  );

  return (
    <Container unit={unit}>
      <StyledSlider
        id="typeinp"
        type="range"
        min="0"
        max={max}
        value={draftTheme[label.name] || baseTheme[label.name]}
        onChange={handleChange}
        step="1"
      />
      <Input
        type="number"
        min="0"
        max={unit === "pixel" ? 1000 : max}
        className="announcement-title"
        value={draftTheme[label.name] || baseTheme[label.name]}
        placeholder={baseTheme[label.name]}
        onChange={handleChange}
      />
      <span className="unit">{unit === "pixel" ? "px" : "%"}</span>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  position: relative;
  ${Input} {
    min-width: 100px;
    max-width: 120px;
    margin-left: 10px;
    border-width: 1px;
  }
  .unit {
    position: absolute;
    right: 35px;
    top: 26px;
    color: ${props => props.theme["$gray-5"]};
  }
`;

const StyledSlider = styled.input`
  position: relative;
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  height: 2px;
  border-radius: 10px;
  background: ${props => props.theme["$blue-med"]};
  outline: none;
  opacity: 0.7;
  margin-bottom: 4px;
  transition: opacity 0.2s;
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 15px;
    display: block;
    width: 15px;
    height: 15px;
    overflow: hidden;
    background: ${props => props.theme["$blue"]};
    cursor: pointer;
    border: 0;
  }
  ::-moz-range-thumb {
    border-radius: 15px;
    width: 15px;
    height: 15px;
    background: ${props => props.theme["$blue"]};
    cursor: pointer;
    border: 0;
  }
  ::-moz-range-progress {
    background-color: ${props => props.theme["$blue"]};
  }
  ::-moz-range-track {
    background-color: ${props => props.theme["$blue-light"]};
  }
`;

ThemeSlider.propTypes = {
  label: PropTypes.object.isRequired,
  draftTheme: PropTypes.object.isRequired,
  setDraftTheme: PropTypes.func.isRequired
};

export default ThemeSlider;
